module.exports = __webpack_public_path__ + "img/jardin10.a2f59af9.jpg";